// Shared with you (Features 1, sharing): for someone signed in with no board of their own, the boards others shared
// with them, each opening here. Viewing is free; a board of their own (and editing) starts from signing in again.

import { useEffect, useState } from "react";
import { ArrowRight, Eye } from "lucide-react";
import type { SharedBoard } from "../../shared/sharing";
import { api } from "../lib/api";
import { getViewer, readShared, setViewer, sharedHref } from "../state/guest";
import { Backdrop } from "../themes/Backdrop";
import { resolveTheme, THEME } from "../themes/themes";
import { Logo } from "./Logo";
import { signinTheme } from "./signinTheme";

export function SharedHome() {
  const [scene] = useState(signinTheme);
  const theme = resolveTheme({ id: scene });
  const [list, setList] = useState<SharedBoard[] | null>(null);
  const [err, setErr] = useState<string | null>(null);
  useEffect(() => {
    readShared()
      .then(setList)
      .catch((e: Error) => setErr(e.message));
  }, []);
  const signOut = async () => {
    const v = getViewer();
    if (v) await api("/api/viewer/logout", { body: {}, token: v }).catch(() => null);
    setViewer(null);
    location.href = "/";
  };
  return (
    <div className="board-root welcome" data-mode="dark" style={theme.vars as React.CSSProperties}>
      <Backdrop def={THEME[scene]} motion={false} dim={0.1} />
      <header className="welcome-top">
        <Logo />
        <button className="welcome-link link-btn" onClick={() => void signOut()}>
          Sign out
        </button>
      </header>
      <main className="welcome-main shared-home">
        <h1>
          Shared
          <br />
          <em>with you.</em>
        </h1>
        <p className="welcome-sub">Boards people shared with you. Viewing them is free.</p>
        {err && <p className="signin-err">{err}</p>}
        {list === null && !err && <p className="note">Looking…</p>}
        {list?.length === 0 && <p className="note">Nothing is shared with you right now.</p>}
        <div className="shared-list">
          {list?.map((b) => (
            <a key={`${b.ws}.${b.board}`} className="shared-row island" href={sharedHref(b)}>
              <span className="shared-row-emoji" aria-hidden>
                {b.emoji || "▦"}
              </span>
              <span className="shared-row-words">
                <b>{b.name || "A board"}</b>
                <small>
                  {/* with no board of their own, a person views: editing needs a subscription of their own */}
                  Shared by {b.owner ?? "its owner"} · <Eye size={11} /> Can view{b.role === "edit" ? " (edit with a subscription)" : ""}
                </small>
              </span>
              <ArrowRight size={15} />
            </a>
          ))}
        </div>
        <p className="note shared-own">
          Want boards of your own? <a href="https://contextbolt.com/board/">See what Context Board does</a>, then sign out and sign in again to start one.
        </p>
      </main>
    </div>
  );
}
